import { TextFilterType } from '../../../../../types';
import { TaskStatus } from '../../../../../main/tasks/tasksTypes';
import { InvoiceStatus } from '../../../../../main/invoices/invoicesTypes';

export type UniversalFilterTaskStatusStatus = TaskStatus;
export type UniversalFilterInvoiceStatusStatus = InvoiceStatus;

export const enum UniversalFilterTaskStatusModes {
  IS_ANY_OF = 'is_any_of',
  IS_NONE_OF = 'is_none_of'
}

export type UniversalFilterTaskStatusValue = TextFilterType;

export type UniversalFilterTaskStatusFilterState = {
  mode: UniversalFilterTaskStatusModes;
  statuses?: UniversalFilterTaskStatusStatus[];
};

export type UniversalFilterTaskStatusFilterOptions = {
  availableStatuses: UniversalFilterTaskStatusStatus[];
};

export type UniversalFilterTaskStatusOnFilterStateChange = (
  state: UniversalFilterTaskStatusFilterState
) => void;

export type UniversalFilterTaskStatusOnChange = (
  value?: UniversalFilterTaskStatusValue
) => void;

export type UniversalFilterInvoiceStatusFilterOptions = {
  availableStatuses: UniversalFilterInvoiceStatusStatus[];
};
